routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
  $stateProvider
    .state('editProfile', {
      url: '/edit/profile',
      template: require('./index.html'),
      controller: 'EditProfileController',
      controllerAs: 'editProfile',
      authRequired: true,
      resolve: {
        secure: (panel) => {
          // todo: implement method
        }
      },
      onEnter: function (secure) {
        // todo: implement method
      }
    })
}



// WEBPACK FOOTER //
// ./src/app/features/edit-profile/routes.js